export default __webpack_public_path__ + "static/media/solucao-06.f7c56f66.webp";